<div [class.is-expanded]="isExpanded" class="entry-accordion">
  <!-- HEADER -->
  <div class="entry-header flex justify-between items-center">
    <div (click)="toggleExpand.emit()" class="left flex flex-row justify-start items-baseline gap-[10px] grow cursor-pointer">
      <div class="entry-heading text-type-8">{{ form?.controls['type']?.value || lineItem?.type }}</div>
      @if (!isExpanded && summary) {
        <div class="entry-summary text-type-14">{{ summary }}</div>
      }
    </div>
    <div class="right flex justify-center items-center gap-[20px]">
      <mat-icon
        (click)="toggleExpand.emit()"
        [svgIcon]="isExpanded ? 'chevron-up' : 'chevron-down'"
        class="chevron-icon"
      />
      @if (editable) {
        <mat-icon [matMenuTriggerFor]="lineItemMenu" class="menu-icon">more_horiz</mat-icon>
        <mat-menu #lineItemMenu="matMenu">
          <button (click)="deleteClicked.emit()" mat-menu-item>
            <mat-icon svgIcon="trash" />
            Delete
          </button>
        </mat-menu>
      }
    </div>
  </div>

  <!-- BODY -->
  @if (isExpanded) {
    <div class="entry-content">
      <app-dropdown
        (checkForErrors)="checkForErrors.emit($event)"
        (itemAdded)="typeAdded.emit($event)"
        [enableAddItem]="true"
        [enableSearch]="true"
        [error]="errorMessages['type']"
        [options]="typeOptions"
        [parentFormGroup]="form"
        class="mb-[20px]"
        controlName="type"
        label="{{ isEquipment ? 'Equipment' : 'Labor' }}"
      />

      @if (isEquipment) {
        <div class="flex flex-row justify-between items-center mb-[24px] gap-[20px] w-full">
          <div class="label text-type-13">RENTAL:</div>
          <mat-slide-toggle
            (change)="onRentalToggle($event)"
            [checked]="form.controls['is_rental'].value"
            [disabled]="form.disabled"
            class="slide-toggle-btn"
            color="primary"
          />
        </div>
      }

      <app-dropdown
        (checkForErrors)="checkForErrors.emit($event)"
        [enableClearSelection]="true"
        [enableSearch]="subContractorOptions.length >= 10"
        [error]="errorMessages['sub_contractor']"
        [options]="subContractorOptions"
        [parentFormGroup]="form"
        class="mb-[20px]"
        controlName="sub_contractor"
        label="Contractor"
      />

      @if (isEquipment) {
        <div class="flex flex-row justify-center items-center mb-[20px] gap-[20px] w-full">
          <app-number-input
            (checkForErrors)="checkForErrors.emit($event)"
            [error]="errorMessages['quantity']"
            [parentFormGroup]="form"
            class="w-1/2"
            controlName="quantity"
            label="quantity"
          />
          <app-text-input
            (checkForErrors)="checkForErrors.emit($event)"
            [error]="errorMessages['model']"
            [parentFormGroup]="form"
            class="w-1/2"
            controlName="model"
            label="model"
          />
        </div>
      } @else {
        <app-number-input
          (checkForErrors)="checkForErrors.emit($event)"
          [error]="errorMessages['quantity']"
          [parentFormGroup]="form"
          class="mb-[20px]"
          controlName="quantity"
          label="quantity"
        />
      }

      <div class="flex flex-row justify-center items-center mb-[20px] gap-[20px] w-full">
        <app-number-input
          [parentFormGroup]="form"
          class="w-1/2"
          controlName="duration"
          [isDecimalAllowed]="true"
          label="hours"
        />
        <app-number-input
          [parentFormGroup]="form"
          class="w-1/2"
          controlName="idle_duration"
          [isDecimalAllowed]="true"
          label="Hours Idle"
        />
      </div>

      <app-text-area
        [parentFormGroup]="form"
        class="mb-[8px]"
        controlName="comment"
        label="comment"
      />
    </div>
  }
</div>
